import axios from 'axios';
import {
  BASE_URL
} from "../../config/env";

export const meetingAndMessageUrl = BASE_URL.TEST_HOST_API;

//获取我的消息列表
export const getMessageListApi = (params) => {
    let reqUrl='/api/v1/User/MessageList'
    return axios({
      method: 'get',
      url: meetingAndMessageUrl + reqUrl,
      params:params
    })
  }

//删除一条或者多条消息
export const DeleteMessageApi = (data) => {
    let reqUrl='/api/v1/User/DeleteMessage'
    return axios({
      method: 'delete',
      url: meetingAndMessageUrl + reqUrl,
      data:data
    })
  }

//接口获取消息详情
export const GetMessageDetailApi = (params) => {
    let reqUrl='/api/v1/User/GetMessageDetail'
    return axios({
      method: 'get',
      url: meetingAndMessageUrl + reqUrl,
      params:params
    })
  }

//获取会议使用产品详情
export const GetMeetingProductInfoApi = (params) => {
    let reqUrl=`/api/Products/GetMeetingProductInfoWithOutQrData/meetingId/${params.meetingId}`
    return axios({
      method: 'get',
      url: meetingAndMessageUrl + reqUrl,
    })
}

//申请会议试用授权
export const ApplyMeetingLicensesApi = (params) => {
  let reqUrl=`/api/v1/User/ApplyMeetingLicenses/meetingId/${params.meetingId}`
  return axios({
    method: 'get',
    url: meetingAndMessageUrl + reqUrl,
    //params:params
  })
}

//申请试用中心试用授权
export const ApplyTrialLicensesApi = (params) => {
  let reqUrl=`/api/v1/User/ApplyTrialLicenses/trialId/${params.trialId}`
  return axios({
    method: 'get',
    url: meetingAndMessageUrl + reqUrl,
    //params:params
  })
}

//获取所有代办事项列表，包括待处理、已处理、过期
export const GetBackLogApi = (params) => {
  let reqUrl=`/api/Enterprise/GetBackLog`
  return axios({
    method: 'get',
    url: meetingAndMessageUrl + reqUrl,
    params:params
  })
}

//删除代办事项
export const DeleteBackLogApi = (params) => {
  let reqUrl='/api/Enterprise/DeleteBackLog'
  return axios({
    method: 'delete',
    url: meetingAndMessageUrl + reqUrl,
    params
  })
}

//根据id查询代办事项详情
export const GetBackLogByIdApi = (params) => {
  let reqUrl='/api/Enterprise/GetBackLogById'
  return axios({
    method: 'get',
    url: meetingAndMessageUrl + reqUrl,
    params
  })
}

//编辑代办事项
export const EditBackLogApi = (data) => {
  let reqUrl='/api/Enterprise/EditBackLog'
  return axios({
    method: 'patch',
    url: meetingAndMessageUrl + reqUrl,
    data
  })
}

//编辑代办事项
export const GetBackLogWithInviteRecordApi = (data) => {
  let reqUrl='/api/Enterprise/GetBackLogWithInviteRecord'
  return axios({
    method: 'get',
    url: meetingAndMessageUrl + reqUrl,
    data
  })
}


// WEBPACK FOOTER //
// ./src/js/sprint5meetingAndMessage.js